<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title>
        <span class="headline">ポップアップ</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!queryValid" @click="load()">{{
          $t('app.buttons.search')
        }}</v-btn>
        <v-btn :disabled="results.length === 0" @click="save()">{{
          $t('app.buttons.save')
        }}</v-btn>
        <v-btn @click="show = false">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-form ref="form">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <remote-autocomplete
                :disabled="!buValid"
                label="事業本部"
                url="/divisions/kv?type=BU"
                v-model="query.buId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs12>
              <remote-autocomplete
                label="納入場所"
                url="warehouses/reservable-kv"
                v-model="query.warehouseId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs12>
              <date-picker
                label="納入予定日時間"
                v-model="query.date"
              ></date-picker>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <div class="replaced" v-if="results.length > 0">
        <table>
          <tr>
            <td>BU</td>
            <td>品种group</td>
            <td>上限</td>
          </tr>
          <tr v-for="setting in results" :key="setting.id">
            <td>{{ setting.businessUnitName }}</td>
            <td>{{ setting.productGroupName }}</td>
            <td>
              <v-text-field
                type="number"
                solo
                hide-details
                clearable
                v-model="setting.upperLimit"
              />
            </td>
          </tr>
          <tr>
            <td></td>
            <td>total:</td>
            <td>{{ totalLimit }}</td>
          </tr>
        </table>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    show: false,
    query: {},
    valid: false,
    results: [],
    totalLimit: null,
    user: {},
  }),
  methods: {
    save() {
      var illegalSetting = this.results.find(
        (r) => (r.used || 0) > r.upperLimit
      )
      if (illegalSetting) {
        this.$message(
          'Error',
          '設定本数が予約完了本数より小さいので、更新できません。'
        )
        return
      }

      var currentLimit = this.getLimit()
      if (currentLimit !== this.totalLimit) {
        this.$message(
          'Error',
          '自事業本部内のコンテナ受入枠の総本数は変更前と一致しなければなりません。'
        )
        return
      }
      this.$http
        .put(`/warehouse-container-settings`, this.results)
        .then(() => {
          this.$message('', 'SUCCESS')
          this.show = false
          this.$emit('refresh')
        })
        .catch((err) => {
          this.$message('', err.response.data.message || 'ERROR')
          this.show = false
        })
    },
    getEmployee() {
      this.$http.get(`/employees/current`).then((res) => {
        this.user = res.data
        this.query.buId = this.user.buId
      })
    },
    load() {
      this.$http
        .get(`/warehouse-container-settings`, {
          params: { ...this.query, dateRange: this.query.date },
        })
        .then((res) => {
          this.results = res.data
          this.totalLimit = this.getLimit()
        })
    },
    popup() {
      this.show = true
    },

    getLimit() {
      return this.results
        .map((r) => r.upperLimit)
        .reduce((t, r) => {
          return (t = t + Number(r))
        }, 0)
    },
  },
  computed: {
    buValid() {
      return this.user.companyName === 'SJL'
    },
    queryValid() {
      return this.query.buId && this.query.warehouseId && this.query.date
    },
  },
  mounted() {
    this.getEmployee()
  },
}
</script>
<style scoped>
.replaced {
  padding: 15px;
}
.replaced table {
  border-collapse: collapse;
  width: 100%;
}
.replaced table td {
  border-bottom: 1px solid #ccc;
}
.replaced table th {
  text-align: left;
  border-bottom: 1px solid #369;
}
</style>
